import { ButtonAnchor } from "@dropbox/dash-component-library";
import { Text } from "@dropbox/dig-components/typography";
import { Trans } from "@mirage/translations";
import { useState } from "react";
import { ConversationFeedbackModal } from "../feedback/ConversationFeedbackModal";

import type { PAPEvent } from "@mirage/analytics/events/base/event";
import type { ActionSurfaceComponent } from "@mirage/analytics/events/enums/action_surface_component";

export const CalendarErrorMessage = ({
  conversationId,
  logComposeEvent,
  spanId,
}: {
  conversationId: string;
  logComposeEvent: (
    event: PAPEvent,
    overrides?: { actionSurfaceComponent?: ActionSurfaceComponent },
  ) => void;
  spanId?: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Text size="large">
        <Trans
          i18nKey="calendar_response_error_message"
          components={{
            openModalLink: (
              <ButtonAnchor
                resetStyles={true}
                onClick={() => {
                  setIsOpen(true);
                }}
                aria-haspopup="dialog"
                aria-controls="info-modal"
                style={{
                  fontWeight: "var(--dig-type__weight__strong)",
                }}
              />
            ),
          }}
        />
      </Text>
      {isOpen && (
        <ConversationFeedbackModal
          conversationId={conversationId}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          logComposeEvent={logComposeEvent}
          spanId={spanId}
        />
      )}
    </>
  );
};
